import { SUPABASE_URL } from '@/constants/configs'
import { getFileListAt } from './media'

export { dialog, notice } from './addon'
export { queryString } from './qs'

export function isIE() {
  return new RegExp('MSIE|Trident').test(navigator.userAgent)
}

export function generateId(radix: number = 16) {
  return Math.random().toString(radix).slice(2)
}

export function scrollOff(input: boolean = true) {
  document.body.style.overflowY = input ? 'hidden' : 'auto'
}

export function omit<T = any>(obj: T, key: string): any {
  return Object.fromEntries(Object.entries(obj as any).filter((r) => r[0] !== key))
}

export function s3Prefix(path: string) {
  return `${SUPABASE_URL}/storage/v1/object/public${path}`
}

/**
 * .take(limit).skip((page - 1) * limit)
 * @param payload
 * @param total
 * @param page
 * @param limit
 * @returns
 */
export function createPaginate<P = any>(payload: P[], total: number, page: number, limit: number) {
  const lastPage = Math.ceil(total / limit)
  const nextPage = page + 1 > lastPage ? null : page + 1
  const prevPage = page - 1 < 1 ? null : page - 1

  return {
    data: payload,
    total,
    currentPage: page,
    nextPage,
    prevPage,
    lastPage,
    totalPage: lastPage
  }
}

export function usePaginate<P = any>(payload: P[], total: number, page: number, limit: number) {
  const lastPage = Math.ceil(total / limit)
  const nextPage = page + 1 > lastPage ? null : page + 1
  const prevPage = page - 1 < 1 ? null : page - 1

  return {
    data: payload,
    total,
    currentPage: page,
    nextPage,
    prevPage,
    lastPage
  }
}

/**
 * @param delay Add a delay of milliseconds (default: 1 second)
 */
export async function useDeply(delay: number) {
  return await new Promise((resolve) => setTimeout(resolve, delay))
}

/**
 * Provides a way to easily construct a set of key/value pairs representing form fields and their values,
 * which can then be easily sent using the XMLHttpRequest.send() method.
 *
 * @param {object} data FormData
 */
export function createFormData(data: Record<string, any>): [FormData, any] {
  const formData = new FormData()

  for (const name in data) {
    const value = data[name]
    if (value instanceof FileList) {
      if (value?.length) formData.append(name, value?.item(0)!)
    } else {
      formData.append(name, value)
    }
  }

  return [
    formData,
    {
      'Content-Type': 'multipart/form-data'
    }
  ]
}

/**
 * Convert to format: phone, price.
 *
 * @param input Number, String
 * @param matcher RegExp
 * @param separator String
 */
export function numberFormat(input: string | number, matcher?: RegExp, separator: string = '-') {
  if (typeof input === 'string' && matcher) {
    const matched = input.match(matcher)
    return matched ? matched.slice(1).join(separator) : input
  }

  if (typeof input === 'number' && !matcher) {
    const intl = new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' })
    return intl.format(input)
  }

  return input
}
